/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientSearchEncounterModel } from '../../models/patient-search-encounter-model';

export interface PatientFacilityIdEncountersPatientIdIndexPageSizeGet$Params {
  facilityId: string;
  patientId: string;
  index: number;
  pageSize: number;
}

export function patientFacilityIdEncountersPatientIdIndexPageSizeGet(http: HttpClient, rootUrl: string, params: PatientFacilityIdEncountersPatientIdIndexPageSizeGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientSearchEncounterModel>> {
  const rb = new RequestBuilder(rootUrl, patientFacilityIdEncountersPatientIdIndexPageSizeGet.PATH, 'get');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
    rb.path('patientId', params.patientId, {});
    rb.path('index', params.index, {});
    rb.path('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<PatientSearchEncounterModel>;
    })
  );
}

patientFacilityIdEncountersPatientIdIndexPageSizeGet.PATH = '/Patient/{facilityId}/Encounters/{patientId}/{index}/{pageSize}';
